import React, { useState, useRef, useEffect } from "react";
import "./patientProfile.css";
import Component from "../../Components";
import { useLocation } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import strings from "../../utils/strings";
import { useNavigate } from "react-router-dom";

const PatientProfile = () => {
  const location = useLocation();
  const dispatch = useDispatch();
  const [selectedView, setSelectedView] = useState("patientProfileList");
  const [selectedUserId, setSelectedUserId] = useState(null);

  const nav = useNavigate();
  const privilege = useSelector((state) => state.verifyType.privilege);
  useEffect(() => {
    switch (true) {
      case privilege.hasPatientProfileRight:
        nav(strings.navigation.patientProfile);
        break;
      case privilege.hasTNCright:
        nav(strings.navigation.termsCondition);
        break;
      case privilege.hasNationalIdRight:
        nav(strings.navigation.nationalID);
        break;
      case privilege.hasDepartmentRight:
        nav(strings.navigation.department);
        break;
      case privilege.hasArticleRight:
        nav(strings.navigation.healthArticle);
        break;
    }
  }, [privilege]);

  useEffect(() => {
    if (location.state && location.state.type === "ProfileVerificationRequestReceived") {
      getUserId(location.state.id);
      setSelectedView("verification");
    }
  }, [location.state]);

  const topRef = useRef(null);

  const scrollToTop = () => {
    if (topRef.current) {
      topRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    }
  };

  const getUserId = (userId) => {
    setSelectedUserId(userId);
  };
  return (
    <div className="patientProfile" ref={topRef}>
      {selectedView === "patientProfileList" && <Component.PatientProfileList setSelectedView={setSelectedView} getUserId={getUserId} scrollToTop={scrollToTop} />}
      {selectedView === "patientProfileView" && <Component.PatientFullView setSelectedView={setSelectedView} userId={selectedUserId} />}
      {selectedView === "verification" && <Component.Verification setSelectedView={setSelectedView} userId={selectedUserId} />}
    </div>
  );
};

export default PatientProfile;
